__turbopack_context__.v({
  "container": "CotizadorIframe-module__l4ANAq__container",
});
